module.exports = __webpack_public_path__ + "static/media/satellite.f7e4fb6a.png";